// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3q0p_{width:100%;margin:0 auto 8px;min-height:155px}._3QHKk{cursor:pointer;border:0}._3siqT{border:1px solid grey}._1ExE3{max-width:100%}\n", ""]);
// Exports
exports.locals = {
	"imageContainer": "_3q0p_",
	"thumbnail": "_3QHKk",
	"thumbnail__selected": "_3siqT",
	"clickable": "_1ExE3"
};
module.exports = exports;
